<button
  type="button"
  class="gate-btn"
  [class.gate-btn--open]="action === 'open'"
  [class.gate-btn--close]="action === 'close'"
  [class.gate-btn--busy]="busy"
  [disabled]="disabled"
  [attr.aria-busy]="busy"
  [attr.aria-label]="label"
  [title]="label"
  (click)="onClick($event)"
>
  @if (busy) {
    <span class="gate-btn__spinner" aria-hidden="true"></span>
  } @else if (action === 'close') {
    <!-- Barrier arm lowered, arrow coming down onto it. -->
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="2" y="9" width="5" height="12" rx="1.2" stroke="currentColor" stroke-width="1.8" />
      <path d="M1 21.5h7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      <path d="M7 12.5h15.5" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" />
      <path
        class="gate-btn__arrow"
        d="M15.5 1.5v7m-3-3 3 3 3-3"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  } @else {
    <!-- Barrier arm raised, arrow going up. -->
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="2" y="9" width="5" height="12" rx="1.2" stroke="currentColor" stroke-width="1.8" />
      <path d="M1 21.5h7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      <path d="M5.5 9 17 1.5" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" />
      <path
        class="gate-btn__arrow"
        d="M18.5 22v-9m-3 3 3-3 3 3"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  }
</button>
